import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ButtonsForm from 'ui/form/ButtonsForm';
import DialogButtons from 'ui/dialog/Buttons';
import Fields from 'ui/form/FieldsForm';
import { updateBackupPhone } from '../../service';

const useStyles = makeStyles(theme => ({
    phoneRow: {
        display: 'flex',
        alignItems: 'center',
    },
    clearButton: {
        cursor: 'pointer',
        margin: theme.spacing(),
    },
    phoneInput: {
        width: '60%',
    },
}));

export const BackupPhoneDialog = ({
    onSubmit,
    value = '',
    onUpdate,
    open,
    setup,
    data,
}) => {
    const classes = useStyles();
    const [phone, setPhone] = useState(setup ? '' : value);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        await updateBackupPhone({ phone, confirmCode: data.confirm_code });
        onUpdate({ backup_phone: phone });
        onSubmit();
        setLoading(false);
    };

    const handleClear = () => {
        setPhone('');
    };

    return (
        <Dialog open={open} fullWidth>
            <DialogTitle>Add a backup phone number</DialogTitle>
            <DialogContent>
                <Typography variant="subtitle2">
                    Backup phone number (optional)
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    Providing a fall-back SMS number will allow CyberFOX
                    Password Manager to send your two-factor authentication
                    codes to an alternate device if you lose your primary
                    device.
                </Typography>
                <div className={classes.phoneRow}>
                    <Fields.Phone
                        value={phone}
                        onChange={value => setPhone(value)}
                        label="Phone number"
                        valueFromProps
                        className={classes.phoneInput}
                    />
                    {!setup && (
                        <Typography
                            color="secondary"
                            variant="body2"
                            onClick={handleClear}
                            class={classes.clearButton}
                        >
                            Clear
                        </Typography>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <DialogButtons>
                    {!setup && (
                        <ButtonsForm.BackButton
                            label="Cancel"
                            onClick={onSubmit}
                        />
                    )}
                    <ButtonsForm.NextButton
                        label={setup ? 'NEXT' : 'SAVE'}
                        onClick={handleSubmit}
                        loading={loading}
                    />
                </DialogButtons>
            </DialogActions>
        </Dialog>
    );
};
